class phoneNumber extends HTMLElement {
  connectedCallback() {
    this._phoneNumber();
  }

  get inputElement() {
    return this.querySelector('input');
  }

  _phoneNumber() {
    const iti = window.intlTelInput(this.inputElement, {
      initialCountry: "fr",
      preferredCountries: ["fr", "be", "nl"],
      autoPlaceholder: "aggressive",
      nationalMode: false,
      utilsScript: window.shop.intlTel.intlTelInputUtils,
    });
  }
}

try {
  window.customElements.define('phone-number', phoneNumber);
} catch (e) { }